import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Pin, Directions, Polygon } from "@trackcode/map";

class Scopes extends Component {
  static propTypes = {
    /** clear scope options */
    handleOptions: PropTypes.func.isRequired,
    handleScopes: PropTypes.arrayOf(PropTypes.string).isRequired,
    scopes: PropTypes.shape({})
  };

  static defaultProps = {
    scopes: {}
  };

  filterHandleScopes = scopeName => {
    const { handleScopes } = this.props;

    if (handleScopes.length > 0 && !handleScopes.includes(scopeName)) {
      // do not render this scope
      return false;
    }

    // ignore drivers by default because this scope is handle in <ScopeDrivers />
    return scopeName !== "drivers";
  };

  applyMapOptions = () => {
    const { scopes, handleOptions } = this.props;
    const scopeNames = Object.keys(scopes).filter(
      scopeName => scopes[scopeName] && scopes[scopeName].visible
    );
    handleOptions(scopeNames, scopes);
  };

  componentDidMount() {
    this.applyMapOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scopes !== this.props.scopes) {
      this.applyMapOptions();
    }
  }

  render() {
    const { scopes } = this.props;

    // get scope names
    const scopeNames = Object.keys(scopes).filter(
      scopeName => scopes[scopeName] && scopes[scopeName].visible
    );

    return scopeNames.filter(this.filterHandleScopes).map(scopeName => (
      <Fragment key={scopeName}>
        {scopes[scopeName].polygons.map((props, index) => (
          <Polygon
            key={props.key || `${scopeName}-polygon-${index}`}
            {...props}
          />
        ))}
        {scopes[scopeName].pins.map((props, index) => {
          const {
            key: pinKey,
            useHtmlOverlay,
            fillColor: _fillColor,
            memberLabel: _memberLabel,
            ...pinProps
          } = props;
          const pinKeyResolved = pinKey || `${scopeName}-pin-${index}`;
          if (useHtmlOverlay) {
            return null;
          }
          return (
            <Pin
              key={pinKeyResolved}
              {...pinProps}
            />
          );
        })}
        {scopes[scopeName].directions.map((props, index) => (
          <Directions
            key={props.key || `${scopeName}-direction-${index}`}
            {...props}
          />
        ))}
      </Fragment>
    ));
  }
}

const mapStateToProps = ({ featureMap: scopes }) => ({
  scopes
});

export default connect(mapStateToProps)(Scopes);
